import React, { Fragment } from "react";
import { getParams, end_point, makeUniqueKey } from './helper';
import HamburgerNavbar from './hamburgerNavbar';
import AthleteProfile from './athleteProfile';
import { FormGroup, ControlLabel, FormControl, Button, Checkbox, Col, Row, Tabs, Tab } from 'react-bootstrap'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
var $ = require('jquery')


class userProfile extends React.Component {
  constructor() {
    super();
    this.state = {
      token: getParams().jwt,
      id: '',
      account_holder_first_name: '',
      account_holder_last_name: '',
      account_holder_phone: '',
      account_holder_email: '',
      emergency_contact_first_name:'',
      emergency_contact_last_name:'',
      emergency_contact_email:'',
      emergency_contact_phone:'',
      marketing_opt_out: false,
      athlete_info: [],
      organization_id: localStorage.getItem("organization_id"),
      user_endpoint: `${end_point('users')}/users`,
      orgUDFs: null,
      athlete_spinner: false,
      account_holder_spinner: false,
      account_holder_confirm: false,
      activeTab: 'users',
      initial_account_holder_snapshot: null
    };
    this.hamburgerKey = "hamburger"
  }

  componentDidMount() {
    this.loadPage();
  }

  loadPage = (i, account_holder_updated) => {
    $.ajax({
      headers: {
        "token": this.state.token,
        "organization_id": this.state.organization_id,
        "current_user_needed": true
      },
      method: "GET",
      dataType: "json",
      url: this.state.user_endpoint,
    }).then(data => this.accountHolderGetHandler(data.message[0], account_holder_updated));

    $.ajax({
      headers: {
        "token": this.state.token,
        "organization_id": this.state.organization_id,
      },
      method: "GET",
      dataType: "json",
      url: `${end_point()}/parentPortal`
    }).then(data => {
      //console.log("athletes", data.message.athletes, i)
      if (typeof i === 'number') {
        // if (i) { // works only if index is not 0 
        var updatedAthlete = data.message.athletes[i]
        updatedAthlete.updated = true
        updatedAthlete.spinner = false
        console.log("updatedAthlete - added updated prop", updatedAthlete)
        data.message.athletes.splice(i, 1, updatedAthlete)
      }
      this.setState({ athlete_info: data.message.athletes})
    });

    $.ajax({
      headers: {
        "token": this.state.token,
        "organization_id": this.state.organization_id,
        "league": false
      },
      method: "GET",
      dataType: "json",
      url: `${end_point('organizations')}/organizations`,
    }).then(org => {
      console.log("org from user profile", org)
      this.setState({ orgUDFs: org.udfs ? org.udfs: [] })
    });

  }

  accountHolderGetHandler = (resp, updated) => {
    const initial_account_holder_snapshot = resp ? {
      first_name: resp.first_name || '',
      last_name: resp.last_name || '',
      email: resp.email || '',
      marketing_opt_out: !!resp.marketing_opt_out,
      extras: {
        phone: resp.extras ? resp.extras.phone || '' : '',
        secondary_parent: {
          first_name: resp.extras && resp.extras.secondary_parent ? resp.extras.secondary_parent.first_name || '' : '',
          last_name: resp.extras && resp.extras.secondary_parent ? resp.extras.secondary_parent.last_name || '' : '',
          email: resp.extras && resp.extras.secondary_parent ? resp.extras.secondary_parent.email || '' : '',
          phone: resp.extras && resp.extras.secondary_parent ? resp.extras.secondary_parent.phone || '' : ''
        }
      }
    } : null

    this.setState({
      id: resp._id,
      account_holder_first_name: resp.first_name,
      account_holder_last_name: resp.last_name,
      account_holder_email: resp.email,
      account_holder_phone: resp.extras.phone,
      emergency_contact_first_name: resp.extras.secondary_parent? resp.extras.secondary_parent.first_name : null,
      emergency_contact_last_name: resp.extras.secondary_parent? resp.extras.secondary_parent.last_name : null,
      emergency_contact_email: resp.extras.secondary_parent? resp.extras.secondary_parent.email: null,
      emergency_contact_phone: resp.extras.secondary_parent? resp.extras.secondary_parent.phone: null,
      marketing_opt_out: resp.marketing_opt_out,
      account_holder_spinner: false,
      account_holder_confirm: updated ? true : false,
      initial_account_holder_snapshot
    })
  }

  getAccountHolderFormFields = () => {
    return {
      "first_name": this.state.account_holder_first_name,
      "last_name": this.state.account_holder_last_name,
      "email": this.state.account_holder_email,
      "marketing_opt_out": this.state.marketing_opt_out,
      "extras": {
          "phone": this.state.account_holder_phone,
          "secondary_parent": {
            "first_name": this.state.emergency_contact_first_name,
            "last_name": this.state.emergency_contact_last_name,
            "email": this.state.emergency_contact_email,
            "phone": this.state.emergency_contact_phone
          }
      }
    }
  }

  handleAccountHolderSubmit = () => {
    if(this.state.account_holder_email.toLowerCase() === this.state.emergency_contact_email.toLowerCase()){
      alert("Secondary email cannot be same as parent email");
    } else {
      var id = this.state.id;
      var change = this.getAccountHolderFormFields();
      this.handleUpdateSubmit(change, id, 'account_holder_spinner');  
    }
  }

  handleUpdateSubmit = (change, id, spinner, confirm) => {  
    this.setState({[spinner]: true})  
    var match = this.state.athlete_info.find( athlete => {return athlete.email.toLowerCase() === this.state.account_holder_email.toLowerCase()})
    
    if (match) {
      alert("Athlete email cannot be same as parent email");
    } else {
      var rthis = this;
      $.ajax({
          headers: {
              "token": this.state.token,
              "organization_id": localStorage.getItem("organization_id")
          },
          method: "PATCH",
          contentType: 'application/json',
          data: JSON.stringify({
              "id": id,
              "change": change
          }),
          url: this.state.user_endpoint,
          success: function (data) {
              if (data.errorMessage) {
                alert(data.errorMessage);
              } else {
                var i = null
                if (spinner === "account_holder_spinner") {
                  rthis.setState({account_holder_confirm: true})
                } else {
                  var updatedAthlete = rthis.state.athlete_info.find(user => {return user._id === id })
                  i = rthis.state.athlete_info.indexOf(updatedAthlete)
                  console.log('sent. updated Athlete', updatedAthlete)
                }

                rthis.loadPage(i, spinner === "account_holder_spinner" ? "account_holder_updated": null);
              }
          },
          error: function (data){
            alert("Unable to update the profile at the moment, please contact support")
          }
        })
    }
  }

  handleChange = (field, e) => {
    this.setState({
      [field]: e.target.value,
      account_holder_confirm: false
    })
  }

  handleMarketingChange = () => {
    var marketing_opt_out = this.state.marketing_opt_out
    this.setState({ marketing_opt_out: !marketing_opt_out })
  }

  getAccountHolderSnapshot = () => ({
    first_name: this.state.account_holder_first_name || '',
    last_name: this.state.account_holder_last_name || '',
    email: this.state.account_holder_email || '',
    marketing_opt_out: !!this.state.marketing_opt_out,
    extras: {
      phone: this.state.account_holder_phone || '',
      secondary_parent: {
        first_name: this.state.emergency_contact_first_name || '',
        last_name: this.state.emergency_contact_last_name || '',
        email: this.state.emergency_contact_email || '',
        phone: this.state.emergency_contact_phone || ''
      }
    }
  })

  isAccountHolderDirty = () => {
    return JSON.stringify(this.getAccountHolderSnapshot()) !== JSON.stringify(this.state.initial_account_holder_snapshot || {})
  }

  renderUsersTab = () => {
    return (
      <>
        <Col sm={12}>
          <h2>Account Holder</h2>
          <br/>
          <Row>
            <Col sm={6}>
              <FormGroup>
                <ControlLabel>First Name</ControlLabel>
                <FormControl className="opaque-grey" name="account_holder_first_name" type="text" id="account_holder_first_name" value={this.state.account_holder_first_name} onChange={(e) => this.handleChange('account_holder_first_name', e)}/>
              </FormGroup>
            </Col>
            <Col sm={6}>
              <FormGroup>
                <ControlLabel>Last Name</ControlLabel>
                <FormControl className="opaque-grey" name="account_holder_last_name" type="text" id="account_holder_last_name" value={this.state.account_holder_last_name} onChange={(e) => this.handleChange('account_holder_last_name', e)} />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <FormGroup>
                <ControlLabel>Email</ControlLabel>
                <FormControl className="opaque-grey" type="text" name="account_holder_email" id="account_holder_email" value={this.state.account_holder_email} onChange={(e) => this.handleChange('account_holder_email', e)} />
              </FormGroup>
            </Col>
            <Col sm={6}>
              <FormGroup>
                <ControlLabel>Phone</ControlLabel>
                <FormControl className="opaque-grey" name="account_holder_phone" type="text" id="account_holder_phone" value={this.state.account_holder_phone} onChange={(e) => this.handleChange('account_holder_phone', e)} />
              </FormGroup>
            </Col>
          </Row>
          <h2>Secondary Contact</h2>
          <br/>
          <Row>
            <Col sm={6}>
              <FormGroup>
                <ControlLabel>First Name</ControlLabel>
                <FormControl className="opaque-grey" name="emergency_contact_first_name" type="text" id="emergency_contact_first_name" value={this.state.emergency_contact_first_name} onChange={(e) => this.handleChange('emergency_contact_first_name', e)}/>
              </FormGroup>
            </Col>
            <Col sm={6}>
              <FormGroup>
                <ControlLabel>Last Name</ControlLabel>
                <FormControl className="opaque-grey" name="emergency_contact_last_name" type="text" id="emergency_contact_last_name" value={this.state.emergency_contact_last_name} onChange={(e) => this.handleChange('emergency_contact_last_name', e)} />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <FormGroup>
                <ControlLabel>Email</ControlLabel>
                <FormControl className="opaque-grey" name="emergency_contact_email" type="text" id="emergency_contact_email" value={this.state.emergency_contact_email} onChange={(e) => this.handleChange('emergency_contact_email', e)}/>
              </FormGroup>
            </Col>
            <Col sm={6}>
              <FormGroup>
                <ControlLabel>Phone</ControlLabel>
                <FormControl className="opaque-grey" name="emergency_contact_phone" type="text" id="emergency_contact_phone" value={this.state.emergency_contact_phone} onChange={(e) => this.handleChange('emergency_contact_phone', e)} />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col sm={3} className="pull-right">
              <FormGroup>
                {
                  this.state.account_holder_confirm ?
                  <div className="email-sent pull-right">
                    <FontAwesomeIcon icon={faCheck} color='green' size="2x"/>
                    <p className="email-text">Profile Updated</p>
                  </div>
                  :
                  this.state.account_holder_spinner ? <div className="enrolment-loader"></div> :
                  <Button className="orange-fill" disabled={!this.isAccountHolderDirty()} onClick={this.handleAccountHolderSubmit}>
                    Update
                  </Button>
                }
              </FormGroup>
            </Col><br/><br/><br/>
          </Row>
        </Col>
        { this.state.orgUDFs &&
          this.state.athlete_info.map(athlete =>
            <AthleteProfile key={makeUniqueKey()} data={athlete} patchUpdateMethod={this.handleUpdateSubmit} orgUDFs={this.state.orgUDFs} organization_id={this.state.organization_id} token={this.state.token} athlete_spinner={this.state.athlete_spinner}/>
          )
        }
      </>
    )
  }

  renderEmailPreferencesTab = () => {
    return (
      <Col sm={12}>
        <div className="dashboard-box margin-2">
          <div className="white-text">
            <h2>Email Preferences</h2>
            <p className="programs-page-subtitle" style={{ marginBottom: '1.5rem' }}>
              Control which Hoopstir messages you want to receive.
            </p>
            <FormGroup>
              <Checkbox
                checked={!this.state.marketing_opt_out}
                name="marketing_opt_out"
                id="marketing_opt_out"
                onClick={this.handleMarketingChange}
              >
                Receive marketing emails
              </Checkbox>
            </FormGroup>
            <Row>
              <Col sm={3} className="pull-right">
                {
                  this.state.account_holder_spinner ? <div className="enrolment-loader"></div> :
                    this.state.account_holder_confirm ?
                    <div className="email-sent pull-right">
                      <FontAwesomeIcon icon={faCheck} color='green' size="2x"/>
                      <p className="email-text">Preferences Updated</p>
                    </div>
                  :
                    <Button className="orange-fill" disabled={!this.isAccountHolderDirty()} onClick={this.handleAccountHolderSubmit}>
                      Save Preferences
                    </Button>
                }
              </Col><br/><br/><br/>
            </Row>
          </div>
        </div>
      </Col>
    )
  }

  render() {
    return (
      <div className="full-page">
        <HamburgerNavbar key={this.hamburgerKey}/>
        <div className="body-wrapper">
          <h2 className="white-text margin-2">My Family</h2>
            <div className="dashboard-box margin-2">
              <div className="white-text">
                <Tabs
                  defaultActiveKey={this.state.activeTab}
                  onSelect={(activeTab) => this.setState({ activeTab })}
                  id="user-profile-tabs"
                  animation={false}
                >
                  <Tab eventKey="users" title="Users">
                    <form>
                      {this.renderUsersTab()}
                    </form>
                  </Tab>
                  <Tab eventKey="email-preferences" title="Email Preferences">
                    <form>
                      {this.renderEmailPreferencesTab()}
                    </form>
                  </Tab>
                </Tabs>
              </div>
            </div>
          <br/><br/><br/>
          </div>
      </div>
    );
  }
}

export default userProfile;
